
import React, { useState } from "react";

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Grid2 from '@mui/material/Grid2';

import PropTypes from 'prop-types';
import Login from "../components/login/Login";
import Signup from "../components/signup/Signup";
import { Toolbar } from "@mui/material";
import { useParams } from "react-router-dom";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SchoolIcon from '@mui/icons-material/School';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import AuthPageBackground from "../components/auth/AuthPageBackground";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ReferralSignup = () => {
  const {id} = useParams();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <AuthPageBackground>
    <Grid2 spacing={2}>
      <Toolbar></Toolbar>

      <Grid2 container spacing={4} sx={{ mt: 6, px: { xs: 2, md: 4 } }}>
        <Grid2 size={{ xs: 0, sm: 4, md: 4 }}>
          <Box sx={{ 
            display: { xs: 'none', sm: 'block' },
            height: '100%',
            pr: { sm: 2, md: 3 }
          }}>
            <Typography
              variant="h4"
              component="h2"
              sx={{
                fontWeight: 700,
                mb: 2,
                color: 'text.primary',
                fontSize: { sm: '1.75rem', md: '2rem' },
              }}
            >
              Practice that adapts to every child
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                color: 'text.secondary',
                fontSize: '1.1rem',
                lineHeight: 1.6,
              }}
            >
              Designed to help students practice at the right level — without pressure.
            </Typography>
            <Stack spacing={3}>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <CheckCircleIcon sx={{ color: 'success.main', mt: 0.5, fontSize: 28 }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, color: 'text.primary' }}>
                    Personalised practice
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                    Questions adjust based on how the student practices
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <CheckCircleIcon sx={{ color: 'success.main', mt: 0.5, fontSize: 28 }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, color: 'text.primary' }}>
                    Accuracy before speed
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                    Students practice without time pressure
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <CheckCircleIcon sx={{ color: 'success.main', mt: 0.5, fontSize: 28 }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5, color: 'text.primary' }}>
                    Clear feedback
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                    Instant insights help students learn from mistakes
                  </Typography>
                </Box>
              </Box>
            </Stack>
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
          <Box sx={{ maxWidth: 450, width: '100%', mx: 'auto' }}>
            <Paper 
              elevation={0}
              sx={{
                borderRadius: 4,
                boxShadow: (theme) => theme.palette.mode === 'dark'
                  ? '0 12px 40px rgba(0, 188, 212, 0.35), 0 0 0 1px rgba(0, 188, 212, 0.25)'
                  : '0 12px 40px rgba(0, 151, 167, 0.15)',
                width: '100%',
                overflow: 'hidden',
                backgroundColor: 'background.paper',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                animation: 'fadeIn 0.5s ease-in',
                '@keyframes fadeIn': {
                  from: { opacity: 0, transform: 'translateY(20px)' },
                  to: { opacity: 1, transform: 'translateY(0)' },
                },
              }}
            >
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} centered onChange={handleChange}>
                  <Tab label="Sign Up" {...a11yProps(0)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <Signup referralCode={id}></Signup>
              </CustomTabPanel>
            </Paper>
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 0, sm: 4, md: 4 }}>
          <Box sx={{ 
            display: { xs: 'none', sm: 'block' },
            height: '100%',
            pl: { sm: 2, md: 3 }
          }}>
            <Typography
              variant="h4"
              component="h2"
              sx={{
                fontWeight: 700,
                mb: 4,
                color: 'text.primary',
                fontSize: { sm: '1.75rem', md: '2rem' },
              }}
            >
              Who is this for?
            </Typography>
            <Stack spacing={3} sx={{ mb: 4 }}>
              <Card
                sx={{
                  backgroundColor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'divider',
                  boxShadow: (theme) => theme.palette.mode === 'dark'
                    ? '0 2px 8px rgba(0,0,0,0.3)'
                    : '0 2px 8px rgba(0,0,0,0.08)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: (theme) => theme.palette.mode === 'dark'
                      ? '0 4px 16px rgba(0,0,0,0.5)'
                      : '0 4px 16px rgba(0,0,0,0.12)',
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                    <SchoolIcon sx={{ color: 'primary.main', fontSize: 32, mt: 0.5 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'text.primary' }}>
                        Students
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                        Practice questions at your level
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
              <Card
                sx={{
                  backgroundColor: 'background.paper',
                  border: '1px solid',
                  borderColor: 'divider',
                  boxShadow: (theme) => theme.palette.mode === 'dark'
                    ? '0 2px 8px rgba(0,0,0,0.3)'
                    : '0 2px 8px rgba(0,0,0,0.08)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: (theme) => theme.palette.mode === 'dark'
                      ? '0 4px 16px rgba(0,0,0,0.5)'
                      : '0 4px 16px rgba(0,0,0,0.12)',
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                    <FamilyRestroomIcon sx={{ color: 'primary.main', fontSize: 32, mt: 0.5 }} />
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, color: 'text.primary' }}>
                        Parents
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
                        Support and track your child's progress
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Stack>
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                backgroundColor: 'primary.light',
                background: (theme) => theme.palette.mode === 'dark'
                  ? 'linear-gradient(135deg, rgba(100, 181, 246, 0.15) 0%, rgba(66, 165, 245, 0.1) 100%)'
                  : 'linear-gradient(135deg, rgba(25, 118, 210, 0.1) 0%, rgba(66, 165, 245, 0.05) 100%)',
                border: '1px solid',
                borderColor: 'primary.main',
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontStyle: 'italic',
                  color: 'text.primary',
                  textAlign: 'center',
                  lineHeight: 1.6,
                }}
              >
                The right kind of practice builds confidence over time.
              </Typography>
            </Box>
          </Box>
        </Grid2>
      </Grid2>
    </Grid2>
    </AuthPageBackground>
  );
};

export default ReferralSignup;
